<template>
  <van-form ref="vanForm" validate-first class="mode">
    <van-cell-group>
      <template v-for="(item, key) of form">
        <van-field
          v-if="item.isSelect"
          :key="item.name"
          input-align="right"
          v-model="item.text"
          :label="item.name"
          :rules="item.value ? item.rules : []"
          placeholder="请选择"
          right-icon="arrow"
          readonly
          @click="showPop(item.name, key)"
        />
        <van-field
          v-else
          :key="item.name"
          input-align="right"
          v-model="item.text"
          :label="item.name"
          :rules="item.value ? item.rules : []"
          placeholder="请输入"
          @input="val => changeValue(val, key)"
        />
      </template>
    </van-cell-group>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="textList.title"
        show-toolbar
        :columns="textList.columns"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, textList.field);
          }
        "
      />
    </van-popup>
  </van-form>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        jhrxm: {
          name: "监护人姓名",
          text: "",
          value: ""
        },
        gx: {
          name: "关系",
          text: "",
          value: "",
          isSelect: true
        },
        zjlx: {
          name: "证件类型",
          text: "",
          value: "",
          isSelect: true
        },
        zjhm: {
          name: "证件号码",
          text: "",
          value: ""
        }
      },
      show: false,
      textList: {
        title: "",
        field: "",
        columns: []
      },
      columns: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changeValue(val, field) {
      this.form[field].value = val;
    },
    async saveData() {
      this.$refs.vanForm.validate().then(
        async () => {
          let params = {
            type: "jhrxx",
            jhrxm: this.form.jhrxm.value,
            gx: this.form.gx.value,
            zjlxdm: this.form.zjlx.value,
            zjlxmc: this.form.zjlx.value,
            zjhm: this.form.zjhm.value,
            jhrindex: this.info.jhrindex
          };

          const res = await Api.saveXjxx(params);
          if (res.code == 1) {
            if (this.info.type === "add") {
              this.$toast.success("学籍" + this.info.title + "增加已提交");
            } else {
              this.$toast.success("学籍" + this.info.title + "修改已提交");
            }
            setTimeout(() => {
              this.$router.replace(
                "/xsxxxgsq/index?active=" + this.info.active
              );
            }, 1500);
          }
        },
        () => {}
      );
    },
    async getList() {
      const res = await Api.findStudentInfo({
        type: "jhrxx",
        jhrindex: this.info.jhrindex
      });
      if (res.code === "1") {
        // 关系
        this.columns.gx = [
          {
            values: [
              { text: "父亲", value: "0" },
              { text: "母亲", value: "1" },
              { text: "兄弟姐妹", value: "2" },
              { text: "其它", value: "3" }
            ]
          }
        ];
        let message = res.data.jhrInfo;
        let defaultZjlx = 0;
        // 证件类型
        this.columns.zjlx = [
          {
            values: res.data.selectDataMap.zjlx.map((item, index) => {
              if (this.info.type === "update" && item.dm === message.sfzjm) {
                defaultZjlx = index;
              }
              return {
                text: item.dmmc,
                value: item.dm
              };
            }),
            defaultIndex: defaultZjlx
          }
        ];

        if (this.info.type === "update") {
          this.form = {
            jhrxm: {
              name: "监护人姓名",
              text: message.xm,
              value: message.xm
            },
            gx: {
              name: "关系",
              text: message.gxm,
              value: message.gx,
              isSelect: true
            },
            zjlx: {
              name: "证件类型",
              text: message.zjlxmc,
              value: message.sfzjm,
              isSelect: true
            },
            zjhm: {
              name: "证件号码",
              text: message.sfzjh,
              value: message.sfzjh
            }
          };
          this.columns.gx[0].defaultIndex = Number(message.gx);
        }
      }
    },
    // 弹出选择器
    showPop(title, field) {
      this.show = true;
      this.textList.title = title;
      this.textList.field = field;
      this.textList.columns = this.columns[field];
    },
    // 选择确认
    onConfirm(value, index, field) {
      this.show = false;
      this.form[field].text = value[0].text;
      this.form[field].value = value[0].value;
      //   this.getList();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/newPages/student/xsxxxgsq/mode/jhrxx.vue